// The function returns the JSON-LD structured data, which is a script that can
// be placed anywhere on a web page that communicates Schema.org structured data
import type { ProductReviews } from '../reviewHelper';

interface Props {
  name: string;
  sku?: string;
  brandName: string;
  url:string;
  productReviews: ProductReviews;
  image?: string;
  description?: string;
  category?: string;
  price?: string;
}

export const addProductStructuredData = ({
  name, description, sku, image, url, price, brandName, category, productReviews,
}: Props) => {
  const offers = price && {
    '@type': 'Offer',
    url,
    itemCondition: 'https://schema.org/NewCondition',
    availability: 'https://schema.org/InStock',
    price,
    priceCurrency: 'EUR',
  };

  const aggregateRating = productReviews?.reviews.length > 0 ? {
    '@type': 'AggregateRating',
    ratingValue: (productReviews.average_rating / 2),
    ratingCount: productReviews.results_count,
  } : undefined;

  const brand = brandName && {
    '@type': 'Brand',
    name: brandName,
  };

  // https://schema.org/Product
  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name,
    sku,
    mpn: sku,
    image,
    description,
    category,
    brand,
    offers,
    aggregateRating,
  };
};
